import React from 'react';
import "../styles.scss";
import skillIcon from '../assets/skill.png';
import scrumIcon from '../assets/scrum.png';
import { useLanguage } from '../context/LanguageContext';

const Skill = () => {
    const { t } = useLanguage();

    return (
        <section className="skills-section">
            <div className='row align-items-center g-4 skills-hero'>
                <div className="col-lg-8">
                    <h1 className="text-wrap mb-2">{t.skills.title}</h1>
                    <p className="text-white skills-intro">{t.skills.intro}</p>
                </div>
                <div className='col-lg-4 skills-hero-media'>
                    <img src={skillIcon} className="skills-hero-image" alt={t.skills.imageAlt} />
                </div>
            </div>

            <div className="row g-4 skills-strengths-grid">
                {t.skills.strengths.map((item) => (
                    <div className="col-lg-4" key={item.title}>
                        <article className="skills-highlight-card h-100">
                            <h2 className="skills-highlight-title">{item.title}</h2>
                            <p className="text-white-50 mb-0">{item.description}</p>
                        </article>
                    </div>
                ))}
            </div>

            <div className="skills-block">
                <div className="d-flex justify-content-between align-items-end flex-wrap gap-3 mb-4">
                    <div>
                        <h2 className="text-wrap mb-1">{t.skills.coreStackTitle}</h2>
                        <p className="text-white-50 mb-0 skills-section-copy">{t.skills.coreStackIntro}</p>
                    </div>
                </div>
                <div className="row g-4">
                    {t.skills.coreStack.map((group) => (
                        <div className="col-lg-6" key={group.title}>
                            <article className="skills-card h-100">
                                <p className="skills-card-title mb-3">{group.title}</p>
                                <div className="skills-pill-group">
                                    {group.items.map((item) => (
                                        <span className="skills-pill" key={`${group.title}-${item}`}>{item}</span>
                                    ))}
                                </div>
                            </article>
                        </div>
                    ))}
                </div>
            </div>

            <div className="skills-block">
                <div className="row align-items-center g-4">
                    <div className="col-lg-8">
                        <h2 className="text-wrap mb-1">{t.skills.deliveryTitle}</h2>
                        <p className="text-white-50 mb-0 skills-section-copy">{t.skills.deliveryIntro}</p>
                    </div>
                    <div className="col-lg-4 text-center">
                        <img src={scrumIcon} className="skills-secondary-image" alt={t.skills.secondaryImageAlt} />
                    </div>
                </div>
                <div className="row g-4 mt-1">
                    {t.skills.deliverySkills.map((group) => (
                        <div className="col-lg-6" key={group.title}>
                            <article className="skills-card h-100">
                                <p className="skills-card-title mb-3">{group.title}</p>
                                <div className="skills-pill-group">
                                    {group.items.map((item) => (
                                        <span className="skills-pill skills-pill-soft" key={`${group.title}-${item}`}>{item}</span>
                                    ))}
                                </div>
                            </article>
                        </div>
                    ))}
                </div>
            </div>

            <div className="skills-block">
                <h2 className="text-wrap mb-3">{t.skills.softSkillsTitle}</h2>
                <div className="skills-pill-group">
                    {t.skills.softSkills.map((item) => (
                        <span className="skills-pill skills-pill-soft" key={item}>{item}</span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skill;
